import { faDigits, formatMoney } from "@kitchen/ui";

/** "1.5" / "۱٫۵" → 1500 thousandths; null when not a positive amount with at most 3 decimals. */
export function parseMilli(input: string): number | null {
  const ascii = input
    .replace(/[۰-۹]/g, (d) => String("۰۱۲۳۴۵۶۷۸۹".indexOf(d)))
    .replace(/[٠-٩]/g, (d) => String("٠١٢۳۴۵۶۷۸۹".indexOf(d)))
    .replace(/[٫,]/g, ".")
    .trim();
  const m = /^(\d{1,7})(?:\.(\d{1,3}))?$/.exec(ascii);
  if (!m) return null;
  const whole = Number(m[1]) * 1000;
  const frac = Number((m[2] ?? "").padEnd(3, "0") || "0");
  const n = whole + frac;
  return n > 0 ? n : null;
}

/** 1500 → "1.5" without trailing zeros, or "1" */
export function formatMilli(n: number): string {
  const isNeg = n < 0;
  const abs = Math.abs(n);
  const whole = Math.trunc(abs / 1000);
  const frac = String(abs % 1000)
    .padStart(3, "0")
    .replace(/0+$/, "");
  const res = frac ? `${String(whole)}٫${frac}` : String(whole);
  return isNeg ? `−${res}` : res;
}

/** Formatted with Persian digits and optional unit: e.g. "۱٫۵ کیلوگرم" */
export function formatQty(milli: number, unit?: string): string {
  const text = faDigits(formatMilli(milli));
  return unit ? `${text} ${unit}` : text;
}

/** Toman string input (Persian or Latin digits) to integer Rial (x10) */
export function parseTomanToRial(input: string): number | null {
  const ascii = input
    .replace(/[۰-۹]/g, (d) => String("۰۱۲۳۴۵۶۷۸۹".indexOf(d)))
    .replace(/[٠-٩]/g, (d) => String("٠١٢۳۴۵۶۷۸۹".indexOf(d)))
    .replace(/[,٬]/g, "")
    .trim();
  if (!ascii || !/^\d+$/.test(ascii)) return null;
  const toman = Number(ascii);
  return Number.isSafeInteger(toman) ? toman * 10 : null;
}

export function formatRial(rial: number): string {
  return formatMoney(rial, "toman");
}
